module.exports = __webpack_public_path__ + "static/media/before-you-start.5845dfa4.svg";